import { useEffect, useRef, useState } from 'react';
import usePageSize, { PageSizeChoice } from './usePageSize';

/** The query string at first render, so list state can start from a shared link. */
export const initialParams = () => new URLSearchParams(window.location.search);

const readPage = () => {
  const page = parseInt(initialParams().get('page') ?? '', 10);
  return page > 0 ? page : 1;
};

// Paging state shared by every list page: the current page (from ?page= on load), the rows
// per page, and "back to page 1" whenever the filters or the page size change.
export default function useListPage(reservedHeight: number, filterKey: string) {
  const [currentPage, setCurrentPage] = useState(readPage);
  const { pageSize, setPageSize, isAuto, fitSize } =
    usePageSize(reservedHeight);

  const firstRun = useRef(true);
  useEffect(() => {
    // Not on mount: the page came from the URL and the filters are still the initial ones.
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    setCurrentPage(1);
  }, [filterKey, pageSize]);

  const onPageSizeChange = (size: PageSizeChoice) => setPageSize(size);

  return {
    currentPage,
    setCurrentPage,
    pageSize,
    onPageSizeChange,
    isAuto,
    fitSize,
  };
}
